import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

export async function fetchElectronicInvoicingServices({ commit, state }) {
    await $http
        .get("/api/electronic-invoicing-services")
        .then(response => {
            commit('fetchElectronicInvoicingService', response.data.data[0])
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error",
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function calculateFolios({ commit, state }, { last_recharge_date, last_recharge_folios }) {
    let result = null;
    await $http
        .post("/api/electronic-invoicing-services/calculate-folios", { last_recharge_date, last_recharge_folios })
        .then(response => {
            result = response.data.data;
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "No fue posible calcular los folios",
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    return result;
}

export async function updateElectronicInvoicingServices({ commit, state }, data) {
    await $http
        .post("/api/electronic-invoicing-services", data)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Actualizado con exito.",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error",
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/electronic-invoicing-services/actions.js